import React from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from 'react-spring'
import Cards11 from "./Cards_11";
import { NavLink, Link } from "react-router-dom";

const calc = (x, y) => [-(y - window.innerHeight / 2) / 20, (x - window.innerWidth / 2) / 20, 1.1]
const trans = (x, y, s) => `perspective(600px) rotateX(${x}deg) rotateY(${y}deg) scale(${s})`

/*<div className="">
            <animated.div
                    class="card7"
                    onMouseMove={({ clientX: x, clientY: y }) => set({ xys: calc(x, y) })}
                    onMouseLeave={() => set({ xys: [0, 0, 1] })}
                    style={{ transform: props.xys.interpolate(trans) , backgroundImage:  'url("./pictures/images_7.jpg")' }}     
            /> 

        </div>*/

function Card() {
  const [props, set] = useSpring(() => ({ xys: [0, 0, 1], config: { mass: 5, tension: 350, friction: 40 } }))

  var divStyle = {
    color: 'blue',
    cursor: 'pointer',
  }
  
  return (
    <div className="">


        <div   id = "signal-report"    className="card-7" style={{ backgroundImage:  'url("./pictures/background_6.jpg")' }}   >
  
          <br></br>
          <a     id ="Strategy" aria-expanded="false" ><img className=""  width="170px" height="70px" src="./pictures/images_6.jpg"></img><span className="doc-content-title">Trading Platform Simulator (Coming Soon) </span></a>
                            <div className="wrapper_line"></div>

                            <br></br>

                  <p id="page_summary_id" className="page_summary_id">
                  The iDMS Stock Simulator comes close to replicating the real-life experience of trading including how our engine interactively responds by providing profit and loss, alerts, signals and risk management associated to the underlying trade (exit strategies and other states).
                  
                  <br></br>  
                  <br></br>  

                  <NavLink
                    exact
                    to="/solution"
                    cursor= "pointer"
                    style = {divStyle}
                  >
                    Learn more ...
                  </NavLink>
                

                  <br></br>  
                  </p>


                  <br></br>
            
        </div>
        <br></br>


</div>

  )
};

export default Card; 


